import React, { useEffect, useState } from 'react';
import { Box, Container, Grid, Typography, Tabs, Tab } from '@mui/material';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { getReviewByProduct } from '../../services/Review';
import { useParams } from 'react-router-dom';

const ProductReview = ({ productData }) => {
    const { isSmallScreen } = useMediaQueries();
    const [activeTab, setActiveTab] = useState(0);
    const [reviewData, setReviewData] = useState([])
    const { id } = useParams()

    const getReviewData = async () => {
        try {
            const response = await getReviewByProduct(id);
            setReviewData(response?.reviewData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getReviewData();
    }, []);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const descriptionData = [
        { title: "Warranty", content: productData?.warranty },
        { title: "Hanging Set", content: productData?.hangingSet },
        { title: "Cushion", content: productData?.cushion },
        {
            title: "Maintenance",
            content: (
                <ul style={{ margin: 0, paddingLeft: "20px" }}>
                    {productData?.maintenance?.map((item, index) => (
                        <li key={`${item}-${index}`}>{item}</li> // Ensure unique key
                    ))}
                </ul>
            )
        },
        { title: "Customization Available", content: productData?.customizationAvailable },
    ];

    return (
        <Container sx={{ py: { lg: 3, xs: 3 } }}>

            {
                // reviewData?.length > 0 &&
                // <>
                //     <Typography
                //         data-aos="fade-down"
                //         variant={isSmallScreen ? 'h5' : 'h4'}
                //         sx={{ fontWeight: 700, textAlign: 'center' }}
                //         gutterBottom
                //     >
                //         Product Reviews
                //     </Typography>
                //     <Typography data-aos="fade-up" variant="subtitle1" sx={{ mb: { lg: 6, xs: 3 }, textAlign: 'center' }}>
                //         See What Our Customers Have to Say!
                //     </Typography>
                //     <Grid container spacing={4} >
                //         {reviewData?.map((review, index) => (
                //             <Grid item xs={12} md={6} key={index} sx={{ maxWidth: '100%' }}>
                //                 <Card sx={{ display: "flex", flexDirection: "column", p: 2, boxShadow: '0px 0px 21px 0px #0000000A', height: '100%', border: '1px solid #E3E3E3' }}>
                //                     {/* Images Section */}
                //                     <Box sx={{ mb: 2 }}>
                //                         <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                //                             {review?.reviewImage?.map((image, i) => (
                //                                 <img
                //                                     key={i}
                //                                     src={image?.url}
                //                                     alt={`Image ${i + 1}`}
                //                                     style={{
                //                                         width: "100px",
                //                                         height: "100px",
                //                                         borderRadius: "8px",
                //                                     }}
                //                                 />
                //                             ))}
                //                         </Box>
                //                     </Box>

                //                     {/* Review Content */}
                //                     <CardContent sx={{ p: 0, mb: 2 }}>
                //                         <Typography
                //                             variant="body1"
                //                             sx={{ fontSize: { md: "20px", xs: "18px" }, color: "#333", mb: 2 }}
                //                         >
                //                             {review?.reviewContent}
                //                         </Typography>
                //                     </CardContent>

                //                     {/* Reviewer Section */}
                //                     <Box sx={{ display: "flex", alignItems: "center", mt: "auto" }}>
                //                         <Box>
                //                             <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                //                                 {review.name}
                //                             </Typography>
                //                             <Rating
                //                                 value={review.rating}
                //                                 precision={0.5}
                //                                 sx={{ fontSize: "1.5rem" }}
                //                                 readOnly
                //                             />
                //                         </Box>
                //                     </Box>
                //                 </Card>
                //             </Grid>
                //         ))}
                //     </Grid>
                // </>
            }

            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        mb: 3,
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .MuiTabs-flexContainer': {
                            justifyContent: 'center', // Centers the tabs
                        },
                        '& .Mui-selected': {
                            color: '#01A0E2', // Set selected tab color
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#01A0E2', // Set indicator color
                        },
                    }}
                >
                    <Tab sx={{ fontSize: { lg: '20px', xs: '16px' } }} label="Description" />
                    <Tab sx={{ fontSize: { lg: '20px', xs: '16px' } }} label="Additional Information" />
                    {/* <Tab sx={{ fontSize: { lg: '20px', xs: '16px' } }} label="Review" /> */}
                </Tabs>
                {
                    activeTab === 0 && (
                        <Box>
                            <Grid container spacing={2}>
                                {descriptionData.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Grid item xs={3} >
                                            <Typography
                                                variant={isSmallScreen ? 'body1' : 'h6'}
                                                sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word' }}
                                            >
                                                {item.title}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={9} >
                                            <Box variant="body1">
                                                {item.content}
                                            </Box>
                                        </Grid>
                                    </ React.Fragment>
                                ))}
                            </Grid>
                        </Box>
                    )
                }
                {
                    activeTab === 1 && (
                        <Box>
                            {productData?.additionalInformation?.length > 0 ? (
                                <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                    {productData.additionalInformation.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            ) : (
                                <Typography variant="body1" sx={{ color: 'gray' }}>
                                    No additional information available.
                                </Typography>
                            )}
                        </Box>
                    )
                }

                {/* {
                    activeTab === 2 && (
                        <ReviewForm getReviewData={getReviewData} productData={productData} />
                    )
                } */}
            </Box >
        </Container >
    );
};

export default ProductReview;